import React, { Component } from 'react';
import { Tab, Tabs } from 'material-ui/Tabs';
import ReadyToBill from './ReadyToBill';
import SubmittedClaim from './SubmittedClaim';
import ProccessedClaim from './ProccessedClaim';
import SettledClaims from './SettledClaims';
// import ClaimHistory from './ClaimHistory';
import FontIcon from 'material-ui/FontIcon';
import OAAcknowledgement from './OAAcknowledgement';
import OAandPayerResponse from './OAandPayerResponse';
import { getPatient } from './actions/ManageClaimActions';
import { connect } from 'react-redux';

class ManageClaims extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: props.match.params.id ? parseInt(props.match.params.id) : 0,
      activeTabValue: props.match.params.id ? props.match.params.id : '0',
      slideIndex: null,
      claimHistoryId: null,
      claimId: props.match.params.claimId ? props.match.params.claimId : null,
      isChecked:false,
    };
    this.handleClaimIdTabChange = this.handleClaimIdTabChange.bind(this);

  }

    state = {
      open: false,
    };
    handleOpen = () => {
      this.setState({ open: true });
    };
    handleClose = () => {
      this.setState({ open: false });
    };

    setActive(tabValue) {
      if (tabValue === this.state.activeTab) {
        return false;
      }
      this.setState({ activeTab: tabValue });
    }

    handleToggle = () => {
      this.setState({
        isChecked :!this.state.isChecked
      }, () => {
        let searchObj = {
          locationIds: '0',
          isActiveCheckRequired: 'NO',
          isActiveClientsOnly: this.state.isChecked,
        };
        this.props.getPatient(searchObj);
      });
    }

    componentDidMount(){
      if(this.props.isCalledFromERA){
        this.handleClaimIdTabChange("3")
      }
<ProccessedClaim location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange}  claimId={this.state.claimId} handleToggle = {this.handleToggle} isChecked = {this.state.isChecked}/>
    }

    handleClaimTabChange = (value) => { //  Change Tab on form Submit.

      this.setState({ activeTabValue: value, activeTab: parseInt((value || 0), 10), claimHistoryId: null });
    };

    handleClaimIdTabChange(value, claimId) {
      // console.log('claimId...........................',claimId);
      this.setState({ activeTabValue: value, activeTab: parseInt((value || 0), 10) });
      this.setState({ claimHistoryId: claimId });
    };


    render() {
      var styles = {
        default_tab: {
          height: '50px',
          fontSize: '13px',
        },
        active_tab: {
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.10)',
          height: '48px',
          fontSize: '13px',
        },
      };
      styles.tab = [];
      styles.tab[0] = styles.default_tab;
      styles.tab[1] = styles.default_tab;
      styles.tab[2] = styles.default_tab;
      styles.tab[3] = styles.default_tab;
      styles.tab[4] = styles.default_tab;
      styles.tab[5] = styles.default_tab;
      styles.tab[this.state.activeTab] = styles.active_tab;
      styles.tab[this.state.slideIndex] = Object.assign({}, styles.tab[this.state.slideIndex], styles.active_tab);

      return (
        <div>
          <h2 className="page_title">Manage Claims</h2>
          <Tabs className="custom_tabs" value={this.state.activeTabValue} onChange={this.handleClaimTabChange}>
            <Tab
              onClick={(e) => this.setActive(0)}
              style={styles.tab[0]}
              value="0"
              className="customtab"
              icon={<FontIcon className="material-icons">filter_1</FontIcon>}
              label={<font>Ready To Bill</font>}>
              <div className="readmin-panel">
                {this.state.activeTab === 0 ?
                  <ReadyToBill location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange} handleClaimIdTabChange= {this.handleClaimIdTabChange} handleToggle = {this.handleToggle} isChecked = {this.state.isChecked}/>
                  : null}
              </div>
            </Tab>
            <Tab
              onClick={(e) => this.setActive(1)}
              style={styles.tab[1]}
              value="1"
              className="customtab"
              icon={<FontIcon className="material-icons">filter_2</FontIcon>}
              label={<font>Submitted Claims</font>}>
              <div className="readmin-panel">

              {this.state.activeTab === 1 ?
                  <SubmittedClaim location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange} handleClaimIdTabChange= {this.handleClaimIdTabChange} claimId={this.state.claimId} handleToggle = {this.handleToggle} isChecked = {this.state.isChecked}/>
                  : null}

              </div>
            </Tab>
            <Tab
              onClick={(e) => this.setActive(2)}
              style={styles.tab[2]}
              value="2"
              className="customtab"
              icon={<FontIcon className="material-icons">filter_3</FontIcon>}
              label={<font>Clearinghouse and Payer Response</font>}>
              <div className="readmin-panel">
                {this.state.activeTab === 2 ?
                  <OAandPayerResponse location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange}/>
                  : null}
              </div>
            </Tab>
            <Tab
              onClick={(e) => this.setActive(3)}
              style={styles.tab[3]}
              value="3"
              className="customtab"
              icon={<FontIcon className="material-icons">filter_4</FontIcon>}
              label={<font>EDI Response</font>}>
              <div className="readmin-panel">
                {this.state.activeTab === 3 ?
                     <ProccessedClaim isCalledFromERA={this.props.isCalledFromERA} claimIdFromERA={this.props.claimIdFromERA} dos = {this.props.dosFromERAModule}location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange}  claimId={this.state.claimId} handleToggle = {this.handleToggle} isChecked = {this.state.isChecked}/>
                  : null}

              </div>
            </Tab>           
            <Tab
              onClick={(e) => this.setActive(4)}
              style={styles.tab[4]}
              value="4"
              className="customtab"
              icon={<FontIcon className="material-icons">filter_5</FontIcon>}
              label={<font>Settled Claims</font>}>
              <div className="readmin-panel">
                {this.state.activeTab === 4 ?
                    <SettledClaims location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange} handleToggle = {this.handleToggle} isChecked = {this.state.isChecked}/>
                    // <UnmappedClaim location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange} />
                  : null}
              </div>
            </Tab>
            <Tab
              onClick={(e) => this.setActive(5)}
              style={styles.tab[5]}
              value="5"
              className="customtab"
              icon={<FontIcon className="material-icons">filter_6</FontIcon>}
              label={<font>Clearinghouse Acknowledgement</font>}>
              <div className="readmin-panel">
                {this.state.activeTab === 5 ?
                    <OAAcknowledgement location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange} />
                    // <UnmappedClaim location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange} />
                  : null}
              </div>
            </Tab>
              {/* {this.state.claimHistoryId ?
              <Tab
                onClick={(e) => this.setActive(5)}
                style={styles.tab[5]}
                value="5"
                className="customtab"
                icon={<FontIcon className="material-icons">filter_6</FontIcon>}
                label={<font>Claim History</font>}>
                <div className="readmin-panel">
                  {this.state.activeTab === 5 ?
                    <ClaimHistory claimHistoryId= {this.state.claimHistoryId} location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange} />
                    : null}
                </div>
              </Tab>
              : null } */}
          </Tabs>
        </div>
      );
    }
}

function mapStateToProps(state) {
  return {
    isCalledFromERA:state.billing.isCalledFromERAModule,
    claimIdFromERA: state.billing.claimIdFromERAModule,
    dosFromERAModule:state.billing.dosFromERAModule
  }
}

export default connect(mapStateToProps ,{getPatient})(ManageClaims);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/index.js